import { useEffect, useState } from "react";
import { get_especialidades } from "../../../../services/api";


export type EspecialidadApi = {
  id_especialidad: string;
  name: string;
};

export type EspecialidadOption = { id: string; label: string };

type State = {
  data: EspecialidadOption[];
  loading: boolean;
  error: string | null;
};

export function useEspecialidades() {
  const [state, setState] = useState<State>({
    data: [],
    loading: false,
    error: null,
  });

  useEffect(() => {
    let alive = true;

    const load = async () => {
      setState((p) => ({ ...p, loading: true, error: null }));
      try {
        const res = await get_especialidades();
        const list: EspecialidadApi[] = res?.data?.data ?? [];

        const mapped: EspecialidadOption[] = list.map((e) => ({
          id: e.id_especialidad,
          label: e.name,
        }));

        if (!alive) return;
        setState({ data: mapped, loading: false, error: null });
      } catch (e: any) {
        if (!alive) return;
        setState((p) => ({
          ...p,
          loading: false,
          error: e?.message || "No se pudieron cargar las especialidades.",
        }));
      }
    };

    load();
    return () => {
      alive = false;
    };
  }, []);

  return state;
}
